// This file holds required Angular polyfills imported in all of our Angular apps.
// Polyfills needed only in a specific app should be imported just in that app.

// necessary for Angular metadata decorators
import 'reflect-metadata';
import 'core-js/es/reflect';
// necessary for Angular to handle change detection
import 'zone.js';
